<mat-card> 
    <mat-card-header style="margin-bottom: 20px">
        <mat-card-title>Cliente com Pendências</mat-card-title>
        
        <div fxLayoutAlign="center start">
            <button 
                mat-mini-fab
                matTooltip="Baixar Basket"
                (click)="basket()">
                <mat-icon>cloud_download</mat-icon>
            </button>            
        </div>
        
    </mat-card-header>

    <mat-card-content>
        <div class="tabela_principal mat-elevation-z8 example-container">
            <table mat-table [dataSource]="rows">               

                <ng-container matColumnDef="cliente">
                    <th mat-header-cell *matHeaderCellDef>Cliente</th>
                    <td mat-cell *matCellDef="let element"> {{element.cliente}} </td>
                    <td mat-footer-cell *matFooterCellDef> <b>Total:</b> {{totalClientes}} </td>
                </ng-container>

                <ng-container matColumnDef="motivo_recusa">
                    <th mat-header-cell *matHeaderCellDef>Motivo</th>
                    <td mat-cell *matCellDef="let element"> {{element.motivo_recusa}} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="valor_financeiro_liquido">
                    <th mat-header-cell *matHeaderCellDef>Financeiro Liquido</th>
                    <td mat-cell *matCellDef="let element"> R$ {{element.valor_financeiro_liquido | number : '1.2-2'}} </td>
                    <td mat-footer-cell *matFooterCellDef> <b>R$ {{getTotalLiquido() | number : '1.2-2'}} </b></td>
                </ng-container>

                <ng-container matColumnDef="valor_financeiro_disponivel">
                    <th mat-header-cell *matHeaderCellDef>Financeiro Disponivel</th>
                    <td mat-cell *matCellDef="let element"> R$ {{ (element.valor_financeiro_liquido - element.financeiro_ativo) | number : '1.2-2'}} </td>
                    <td mat-footer-cell *matFooterCellDef> <b> R$ {{getTotalLiquido() | number : '1.2-2'}} </b></td>
                </ng-container>

                <ng-container matColumnDef="ativos_cliente">
                    <th mat-header-cell *matHeaderCellDef>Ativos</th>
                    <td mat-cell *matCellDef="let element"> {{element.ativos_cliente }} </td>
                    <td mat-footer-cell *matFooterCellDef> <b> R$ {{ getTotalAtivo() | number : '1.2-2'}} </b> </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr 
                    mat-row 
                    *matRowDef="let row; columns: columnsToDisplay;"
                    (click)="selectionRow(row)"
                    style="cursor: pointer;"
                >
                </tr>
                <tr mat-footer-row *matFooterRowDef="columnsToDisplay; sticky: true"></tr>
            </table>
        </div>
    </mat-card-content>
</mat-card>